// Lightweight loaders for Google Identity Services and Sign in with Apple.
// Both are wired end-to-end; when the client IDs are still placeholders the
// caller shows a friendly message instead of launching a broken flow.

const isConfigured = (v) => !!v && !String(v).trim().startsWith('<');

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const APPLE_CLIENT_ID = process.env.REACT_APP_APPLE_CLIENT_ID || '';
export const googleConfigured = isConfigured(GOOGLE_CLIENT_ID);
export const appleConfigured = isConfigured(APPLE_CLIENT_ID);

const loadScript = (src, id) =>
  new Promise((resolve, reject) => {
    if (document.getElementById(id)) return resolve(true);
    const s = document.createElement('script');
    s.src = src; s.id = id; s.async = true; s.defer = true;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(s);
  });

// Triggers Google One Tap / popup and resolves with the ID token (credential).
export async function googleSignIn() {
  if (!googleConfigured) throw new Error('not_configured');
  await loadScript('https://accounts.google.com/gsi/client', 'google-gsi');
  return new Promise((resolve, reject) => {
    try {
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: (resp) => resp?.credential ? resolve(resp.credential) : reject(new Error('No credential')),
      });
      window.google.accounts.id.prompt();
    } catch (e) { reject(e); }
  });
}

// Launches Sign in with Apple and resolves with the identity token.
export async function appleSignIn() {
  if (!appleConfigured) throw new Error('not_configured');
  await loadScript('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js', 'apple-idjs');
  window.AppleID.auth.init({
    clientId: APPLE_CLIENT_ID,
    scope: 'name email',
    redirectURI: window.location.origin + '/auth',
    usePopup: true,
  });
  const data = await window.AppleID.auth.signIn();
  const token = data?.authorization?.id_token;
  if (!token) throw new Error('No Apple identity token');
  return token;
}
